var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"register-hint box fixed-width mt-4 centered"},[_c('h2',[_vm._v("Vous n'avez pas encore de compte sur Coloc'Auto ?")]),_c('b-btn',{attrs:{"to":"/register","variant":"outline-primary"}},[_vm._v(" Créer un compte ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }